import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_PUBLIC_BASE_PATH,
  timeout: 10000,
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Do something before the request is sent
    // const token = localStorage.getItem("token");
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    // Handle the request error
    return Promise.reject(error);
  }
);

// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx causes this function to trigger
    if (response && response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      console.error("Something went wrong");
      return Promise.reject(response);
    }
  },
  (error) => {
    // Any status codes that fall outside the range of 2xx cause this function to trigger
    if (error?.response?.status === 401) {
      // Handle unauthorized access (e.g., redirect to login)
      console.error("Unauthorized! Redirecting to login...");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
